import React from 'react';
import { Link } from 'react-router-dom';

import SchoolMainDetails from './SchoolMainDetails';

class SchoolDetails extends React.Component {
  constructor(props) {
    super(props);

    this.makeDetailsPanel = this.makeDetailsPanel.bind(this);
  }

  makeDetailsPanel(school) {
    return (
      <div>
        <SchoolMainDetails school={school} />

        <h3><i className="fa fa-chalkboard-teacher" /> Insegnanti</h3>
        {
          school.teachers ? (
            school.teachers.map((teacher) => {
              return (
                <div>
                  <h4>{teacher.first_name} {teacher.last_name}</h4>
                  <p>
                  Email: {teacher.email ? <a href={'mailto:' + teacher.email}>{teacher.email}</a> : 'N/D'}<br />
                  Tel.: {teacher.phone ? <a href={'tel:' + teacher.phone}>{teacher.phone}</a> : 'N/D'}
                  </p>
                </div>
              );
            })
          ) : (
            <p>Nessun insegnante</p>
          )
        }

        <h3><i className="fa fa-gift" /> Kit</h3>
        {
          school.kits ? (
            school.kits.map((kit) => {
              return (
                <div>
                  <h4>{kit.name}</h4>
                  <p>
                    A.S. {kit.schoolyear}
                  </p>
                </div>
              );
            })
          ) : (
            <p>Nessun kit</p>
          )
        }

        {/* <h3><i className="fa fa-envelope" /> Mailing</h3>
        {
          school.mailings ? (
            <div>
              <p>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRY0MiHtSkdYD4NCaIBlyQT61zK5XvG-JGTkx74HxBiWimRRREQ" style={{width: '1.25em'}} /> Respinte: {school.mailings.num_failed}
              </p>

              <p>
                <i className="fa fa-envelope-open-text" /> Aperture: {school.mailings.num_opened}
              </p>

              <p>
                <img src="data:image/png;base64,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" style={{width: '1.15em'}} /> Click:
                {school.mailings.num_clicked}
              </p>
            </div>
          ) : (
            <p>Nessun mailing</p>
          )
        } */}
      </div>
    );
  }

  render() {
    const school = this.props.school;
    if (!school) {
      return 'NO SCHOOL';
    }

    return (
      <div>
        <div className="row">
          <div className="col-7">
          {this.makeDetailsPanel(school)}
          </div>
          <div className="col-5">
            {
              school.parent_school ? (
                <div className="card">
                  <div className="card-header">
                    <h2 style={{fontSize: '1.5rem', color: '#888'}}><i className="fa fa-university" /> Istituto principale</h2>
                  </div>
                  <div className="card-body">
                    <h3>{school.parent_school.name}</h3>
                    <p><strong>Dirigente scolastico:</strong> {'Mario Rossi'}</p>
                    {this.makeDetailsPanel(school.parent_school)}

                    {
                      school.sibling_schools ? (
                        <div>
                        <h2 style={{fontSize: '1.1rem', color: '#888'}}><i className="fa fa-school" /> Plessi</h2>
                        {
                          school.sibling_schools.map((sibling) => {
                            return <div>{sibling}</div>;
                          })
                        }
                        </div>
                      ) : ''
                    }
                  </div>
                </div>
              ) : ''
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SchoolDetails;



// WEBPACK FOOTER //
// ./src/components/schools/SchoolDetails.js